import {DBBase} from './DBBase';

export class DBActivityLogs extends DBBase {
    /**
     * @param {Object} component
     */
    constructor(component) {
        super(
            component,
            '/activity-logs'
        );
    }
}
